import Logo from "@/assets/icons/inkriv-logo-dark.svg";
import { Link } from "@tanstack/react-router";
import { FaLinkedin, FaTwitter } from "react-icons/fa6";

export const Footer = () => {
  const footerLinks = {
    "quick links": [
      { name: "Features", href: "/#features" },
      { name: "About Us", href: "/about-us" },
    ],
    support: [{ name: "Contact Us", href: "/contact" }],
  };
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white pt-12 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-4  gap-8 mb-12">
          <div>
            <Link
              to="/"
              className="flex items-center mb-4 "
              aria-label="Inkriv Home"
            >
              <img src={Logo} alt={"logo"} />
            </Link>
            <p className="text-gray-600 mb-4 font-satoshi">
              Write Smarter. Research Faster. Elevate Your Work.
            </p>
            {/* <div className="flex space-x-4">
              <a
                href="https://x.com/InkrivAI"
                className="text-gray-400 hover:text-gray-500"
                aria-label="Follow us on X (fka Twitter)"
              >
                <span className="sr-only">X</span>
                <FaTwitter className="w-8 h-8 text-secondary-400" />
              </a>
              <a
                href="https://linkedin.com/in/InkrivAI"
                className="text-gray-400 hover:text-gray-500"
                aria-label="Connect with us on LinkedIn"
              >
                <span className="sr-only">LinkedIn</span>
                <FaLinkedin className="w-8 h-8 text-secondary-700" />
              </a>
            </div> */}
          </div>
          <div></div>
          {Object.entries(footerLinks).map(([category, links], i) => (
            <div key={i}>
              <h3 className="text-sm font-semibold text-neutral-800 uppercase tracking-wider mb-4">
                {category}
              </h3>
              <ul className="space-y-3">
                {links.map((link, i) => (
                  <li key={i}>
                    <Link
                      to={link.href}
                      className="text-sm text-neutral-800 hover:text-neutral-900 font-satoshi"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="pt-8 flex flex-col sm:flex-row flex-wrap justify-center sm:justify-between items-center">
          <p className="text-sm text-gray-500 text-center font-satoshi">
            &copy; {currentYear} Inkriv. All rights reserved.
          </p>
          <div className="mt-4 flex justify-center space-x-6 whitespace-nowrap">
            <Link
              to={`/legal/terms`}
              className="text-sm text-gray-500 hover:text-gray-900 font-satoshi"
            >
              Terms & Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
